<button mat-mini-fab (click)="onClick()" [matTooltip]="label">
  <mat-icon>playlist_add</mat-icon>
</button>
{{ label }}
